"use client";

import * as React from "react";
import { FileText } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Carousel, CarouselContent, CarouselItem } from "@/components/ui/carousel";
const newsItems = [{
  id: 1,
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1606874/img/logo_france_competences_news.png",
  date: "12 Octobre 2023",
  title: "Nouveau référentiel Qualiopi : ce qui change pour vous",
  pdfLink: "#"
}, {
  id: 2,
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1606874/img/logo_ministere_travail_news.png",
  date: "05 Novembre 2023",
  title: "Réforme de la formation professionnelle : les décrets d'application",
  pdfLink: "#"
}, {
  id: 3,
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1606874/img/logo_effet_conseil_doc_news.png",
  date: "20 Décembre 2023",
  title: "Guide pratique de la certification RNCP : étapes et conseils",
  pdfLink: "#"
}];
const partners = [{
  id: 1,
  name: "France Compétences",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1606874/img/partner_france_competences.png"
}, {
  id: 2,
  name: "Qualiopi",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1606874/img/partner_qualiopi.png"
}, {
  id: 3,
  name: "Ministère du Travail",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1606874/img/partner_ministere_travail.png"
}, {
  id: 4,
  name: "Caisse des Dépôts",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1606874/img/partner_caisse_depots.png"
}, {
  id: 5,
  name: "Pôle Emploi",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1606874/img/partner_pole_emploi.png"
}, {
  id: 6,
  name: "Région Île-de-France",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1606874/img/partner_region_idf.png"
}];
export default function CtaFinal() {
  return;
}